import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { GMAnalysisConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { GradeMatrixAnalysisService } from './api/gradeMatrixAnalysis.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class GMAnalysisApiModule {
    public static forRoot(configurationFactory: () => GMAnalysisConfiguration): ModuleWithProviders<GMAnalysisApiModule> {
        return {
            ngModule: GMAnalysisApiModule,
            providers: [ { provide: GMAnalysisConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: GMAnalysisApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('GMAnalysisApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
